import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-artificial-intellegence',
  templateUrl: './artificial-intellegence.component.html',
  styleUrls: ['./artificial-intellegence.component.scss']
})
export class ArtificialIntellegenceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
